import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {
  HomeState,
  HomeTabItemType,
} from '../../../interfaces/reducers/homeState';

const initialState: HomeState = {
  tabs: [],
  isLoading: true,
  isError: false,
  latestNews: [],
};

export const homeTabsSlice = createSlice({
  name: 'homeTabs',
  initialState,
  reducers: {
    homeTabsLoading: state => {
      state.isLoading = true;
      state.isError = false;
    },
    homeTabsFail: state => {
      state.isLoading = false;
      state.isError = true;
    },
    setHomeTabs: (state, action: PayloadAction<HomeTabItemType[]>) => {
      state.tabs = action.payload;
      state.isLoading = false;
      state.isError = false;
    },
    setLatestNews: (state, action: PayloadAction<any[]>) => {
      state.latestNews = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {homeTabsLoading, homeTabsFail, setHomeTabs, setLatestNews} =
  homeTabsSlice.actions;

export default homeTabsSlice.reducer;
